<template>
  <DpplInfoTooltip
    :tooltip="tooltip"
    :icon="icon"
    :icon-color="iconColor"
    :full-width-activator="fullWidthActivator"
    :tooltip-placement="tooltipPlacement"
    :max-width="maxWidth"
    :teleport="teleport"
  />
</template>

<script setup>
import DpplInfoTooltip from '@/components/datapeople/DpplInfoTooltip.vue';

defineProps({
  tooltip: {
    type: Object,
    default: () => ({}),
  },
  icon: {
    type: String,
    default: '$information-outline',
  },
  iconColor: {
    type: String,
    default: 'iconDefault',
  },
  fullWidthActivator: {
    type: Boolean,
    default: false,
  },
  tooltipPlacement: {
    type: String,
    default: 'left',
  },
  maxWidth: {
    type: String,
    default: '208px',
  },
  // On by default so tips stay above charts and sticky headers.
  teleport: {
    type: Boolean,
    default: true,
  },
});
</script>
